module.exports = __webpack_public_path__ + "img/system-selected.0cd45683.png";